'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.warning = exports.error = exports.info = exports.success = exports.hide = exports.show = exports.LEVELS = exports.HIDE_NOTIFICATION = exports.SHOW_NOTIFICATION = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_NOTIFICATION = exports.SHOW_NOTIFICATION = 'tq-plus-admin/notifications/SHOW_NOTIFICATION';
var HIDE_NOTIFICATION = exports.HIDE_NOTIFICATION = 'tq-plus-admin/notifications/HIDE_NOTIFICATION';

var LEVELS = exports.LEVELS = {
    SUCCESS: 'success',
    INFO: 'info',
    ERROR: 'error',
    WARNING: 'warning'
};

var initialState = {
    current: [],
    history: []
};

/* REDUCER
 * ---------------------------------------------------------------------------------------------- */
function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SHOW_NOTIFICATION:
            {
                var type = action.type,
                    rest = (0, _objectWithoutProperties3.default)(action, ['type']); // eslint-disable-line no-unused-vars

                var notification = (0, _extends3.default)({}, rest);

                return (0, _extends3.default)({}, state, {
                    current: [].concat((0, _toConsumableArray3.default)(state.current), [notification]),
                    history: [].concat((0, _toConsumableArray3.default)(state.history), [notification])
                });
            }

        case HIDE_NOTIFICATION:
            return (0, _extends3.default)({}, state, {
                current: state.current.filter(function (notification) {
                    return notification.uid !== action.uid;
                })
            });

        default:
            return state;
    }
}

/* ACTIONS
 * ---------------------------------------------------------------------------------------------- */
var show = exports.show = function show() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LEVELS.SUCCESS;
    return (0, _extends3.default)({
        type: SHOW_NOTIFICATION,
        level: level,
        position: 'tc'
    }, opts, {
        uid: opts.uid || Date.now()
    });
};

var hide = exports.hide = function hide(uid) {
    return {
        type: HIDE_NOTIFICATION,
        uid: uid
    };
};

var success = exports.success = function success(opts) {
    return show(opts, LEVELS.SUCCESS);
};
var info = exports.info = function info(opts) {
    return show(opts, LEVELS.INFO);
};
var error = exports.error = function error(opts) {
    return show(opts, LEVELS.ERROR);
};
var warning = exports.warning = function warning(opts) {
    return show(opts, LEVELS.WARNING);
};

/* eslint-disable */

/* OPTIONS:
 * more info at: [https://github.com/igorprado/react-notification-system]
 * --------------------------------------------------------------------------------------------------
 * title <string = null> - Title of the notification
 * message <string = null> - Message of the notification
 * level <string = null> - Level of the notification. Available: success, error, warning and info [PASSED AS SECOND ARGUMENT]
 * position <string = tc> - 	Position of the notification. Available: tr (top right), tl (top left), tc (top center), br (bottom right), bl (bottom left), bc (bottom center)
 * autoDismiss <integer = 5> - Delay in seconds for the notification go away. Set this to 0 to not auto-dismiss the notification
 * dismissible <bool = true> - Set if notification is dismissible by the user. If set to false, the notification will not display the dismiss ('x') button and will only be dismissible programmatically or after autoDismiss timeout.
 * action <object = null> - Add a button with label and callback function (callback is optional). Add a button and a callback function to the notification. If this button is clicked, the callback function is called (if provided) and the notification is dismissed. [more](https://github.com/igorprado/react-notification-system#action)
 * children <element/string = null> - Adds custom content, and overrides action (if defined). Add custom content / react elements/ [more](https://github.com/igorprado/react-notification-system#children)
 * onAdd <function = null> - A callback function that will be called when the notification is successfully added. The first argument is the original notification e.g. function (notification) { console.log(notification.title + 'was added'); }
 * onRemove <function = null> - A callback function that will be called when the notification is about to be removed. The first argument is the original notification e.g. function (notification) { console.log(notification.title + 'was removed'); }
 * uid <integer/string = null> - Overrides the internal uid. Useful if you are managing your notifications id. Notifications with same uid won't be displayed.

/* eslint-enable */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/notifications.js
// module id = 60
// module chunks = 0